const SCROLL_KEY = 'gb-list-scroll';
const SEARCH_KEY = 'gb-recent-searches';
const SEARCH_VOCAB = [
  'lawn', 'khaddar', 'viscose', 'dhanak', 'linen', 'embroidered', 'unstitched', 'printed', 'floral',
  'winter', 'cotton', 'cambric', 'marina', 'karandi', 'chiffon', 'organza', 'silk', 'suit', 'dupatta',
  'trouser', 'maroon', 'black', 'white', 'green', 'pink', 'yellow', 'beige', 'navy', 'peach',
];

function searchEditDistance(left, right) {
  const grid = Array.from({ length: left.length + 1 }, () => new Array(right.length + 1).fill(0));
  for (let i = 0; i < grid.length; i++) grid[i][0] = i;
  for (let j = 0; j < grid[0].length; j++) grid[0][j] = j;
  for (let i = 1; i < grid.length; i++) {
    for (let j = 1; j < grid[0].length; j++) {
      const cost = left[i - 1] === right[j - 1] ? 0 : 1;
      grid[i][j] = Math.min(grid[i - 1][j] + 1, grid[i][j - 1] + 1, grid[i - 1][j - 1] + cost);
    }
  }
  return grid[left.length][right.length];
}

function correctSearchToken(token, completePrefix) {
  const lower = token.toLowerCase();
  if (lower.length < 4 || SEARCH_VOCAB.includes(lower)) return lower.length < 4 ? token : lower;
  if (lower.endsWith('s') && SEARCH_VOCAB.includes(lower.slice(0, -1))) return lower.slice(0, -1);
  if (lower.endsWith('es') && SEARCH_VOCAB.includes(lower.slice(0, -2))) return lower.slice(0, -2);
  const prefixHits = SEARCH_VOCAB.filter((word) => word.startsWith(lower));
  if (prefixHits.length === 1 && prefixHits[0] !== lower) return completePrefix ? prefixHits[0] : token;
  if (prefixHits.length > 1) return token;
  let best = token;
  let matches = 0;
  for (const word of SEARCH_VOCAB) {
    if (Math.abs(word.length - lower.length) > 1) continue;
    if (searchEditDistance(lower, word) !== 1) continue;
    matches += 1;
    best = word;
  }
  return matches === 1 ? best : token;
}

function correctSearchQuery(value, options = {}) {
  const trimmed = value.trim().replace(/\s+/g, ' ');
  if (!trimmed || trimmed.includes('id:')) return value;
  let text = trimmed.toLowerCase();
  text = text.replace(/\bviscous\b/g, 'viscose');
  text = text.replace(/shalwar\s+kameez/g, 'unstitched suit');
  text = text.replace(/three[\s-]+pieces?/g, '3-piece');
  text = text.replace(/\b3\s*pc\b/g, '3-piece');
  text = text.replace(/\b3\s+pieces?\b/g, '3-piece');
  const corrected = text.split(' ').map((token) => correctSearchToken(token, options.completePrefix === true)).join(' ');
  return corrected === trimmed.toLowerCase() ? trimmed : corrected;
}

globalThis.gbCorrectSearchQuery = correctSearchQuery;

function isListPage() {
  return /\/collections\/|\/search(?:\/|$)/.test(window.location.pathname);
}

document.addEventListener('click', (event) => {
  if (!isListPage()) return;
  const link = event.target.closest('a[href*="/products/"]');
  if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
  try {
    sessionStorage.setItem(SCROLL_KEY, JSON.stringify({
      path: window.location.pathname + window.location.search,
      y: window.scrollY,
    }));
  } catch {
    /* Scroll position is optional. */
  }
}, true);

function restoreListScroll() {
  if (!isListPage()) return;
  let saved;
  try {
    saved = JSON.parse(sessionStorage.getItem(SCROLL_KEY) || 'null');
  } catch {
    return;
  }
  if (!saved || saved.path !== window.location.pathname + window.location.search || !Number.isFinite(saved.y)) return;
  sessionStorage.removeItem(SCROLL_KEY);
  const apply = () => window.scrollTo(0, saved.y);
  apply();
  requestAnimationFrame(apply);
  window.setTimeout(apply, 80);
  window.setTimeout(apply, 400);
}

window.addEventListener('pageshow', restoreListScroll);

function readSearches() {
  try {
    const items = JSON.parse(localStorage.getItem(SEARCH_KEY) || '[]');
    if (!Array.isArray(items)) return [];
    return items.filter((item) => typeof item === 'string' && item.trim() && item.length <= 80).slice(0, 5);
  } catch {
    return [];
  }
}

function saveSearch(term) {
  const value = term.trim();
  if (value.length < 2 || value.length > 80) return;
  const next = [value, ...readSearches().filter((item) => item.toLowerCase() !== value.toLowerCase())].slice(0, 5);
  try {
    localStorage.setItem(SEARCH_KEY, JSON.stringify(next));
  } catch {
    /* Recent searches are optional. */
  }
}

function renderRecentSearches(root) {
  const list = root.querySelector('[data-gb-recent-list]');
  if (!list) return;
  const searches = readSearches();
  list.replaceChildren();
  root.hidden = searches.length === 0;
  searches.forEach((term) => {
    const item = document.createElement('li');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'gb-recent-searches__term';
    button.textContent = term;
    button.addEventListener('click', () => {
      const form = root.closest('form');
      const input = form?.querySelector('input[name="q"]');
      if (!input || !form) return;
      input.value = term;
      saveSearch(term);
      form.requestSubmit();
    });
    item.append(button);
    list.append(item);
  });
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const input = form.querySelector('input[name="q"]');
  if (!(input instanceof HTMLInputElement)) return;
  const corrected = correctSearchQuery(input.value, { completePrefix: true });
  if (corrected && corrected !== input.value) input.value = corrected;
  saveSearch(input.value);
}, true);

function redirectCorrectedSearch() {
  if (!/\/search(?:\/|$)/.test(window.location.pathname)) return;
  const params = new URLSearchParams(window.location.search);
  const query = params.get('q');
  if (!query) return;
  const corrected = correctSearchQuery(query, { completePrefix: true });
  if (!corrected || corrected === query) return;
  params.set('q', corrected);
  window.location.replace(`${window.location.pathname}?${params.toString()}`);
}

redirectCorrectedSearch();

document.addEventListener('focusin', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.name !== 'q') return;
  const root = input.closest('form')?.querySelector('[data-gb-recent-searches]');
  if (root instanceof HTMLElement && input.value.trim() === '') renderRecentSearches(root);
});

document.addEventListener('input', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.name !== 'q') return;
  const root = input.closest('form')?.querySelector('[data-gb-recent-searches]');
  if (!(root instanceof HTMLElement)) return;
  if (input.value.trim() === '') renderRecentSearches(root);
  else root.hidden = true;
});

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-gb-restock]');
  if (!opener) return;
  event.preventDefault();
  event.stopPropagation();
  const dialog = document.getElementById('gb-restock-dialog');
  const body = dialog?.querySelector('[name="contact[body]"]');
  const title = dialog?.querySelector('[data-gb-restock-title]');
  if (!(dialog instanceof HTMLDialogElement) || !(body instanceof HTMLInputElement)) return;
  const productTitle = opener.getAttribute('data-title') || '';
  const productUrl = opener.getAttribute('data-url') || '';
  body.value = `Please tell me when this suit is available again: ${productTitle} (${productUrl})`;
  if (title) title.textContent = productTitle;
  dialog.showModal();
});

document.querySelectorAll('[data-gb-restock-close]').forEach((button) => {
  button.addEventListener('click', () => {
    const dialog = document.getElementById('gb-restock-dialog');
    if (dialog instanceof HTMLDialogElement) dialog.close();
  });
});
